<template>

	<div class="w1200">
		<div class="association-brief-box">
			<div class="crumbs">
				<span><a href="#/">首页 ></a></span>
				<span><a href="#/NewsList/0">资讯 ></a></span>
				<span><a :href="'#/NewsList/' + newInfo.group_id">{{newInfo.group_name}} ></a></span>
				<span>正文</span>
			</div>

		</div>
		<div class="association-news-box clearfix">
			<div class="a-n-left fl">
				<div class="news-left">
					<p class="p01">{{year}}</p>
					<p class="p02">{{day}}</p>
					<p class="p03">{{dateTime}}</p>
					<div class="source">北京建筑设施服务企业协会</div>
					<!--<span class="belonged">{{newInfo.group_name}}</span>-->
					<span class="industry" v-if="newInfo.group_id == 1">{{newInfo.group_name}}</span>
					<span class="international" v-if="newInfo.group_id == 2">{{newInfo.group_name}}</span>
					<span class="association" v-if="newInfo.group_id == 3">{{newInfo.group_name}}</span>
				</div>
			</div>
			<div class="a-n-right fr">
				<div class="new-box">
					<h2>{{newInfo.title}}</h2>
					<p v-html="newInfo.content"></p>
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import Vue from 'vue';
	import Element from 'element-ui';

	export default {

		name: 'HelloWorld',
		data() {
			return {
				path: domain.apiUrl,
				newInfo: {},
				year: "",
				day: "",
				dateTime: "",
			}
		},
		created() {
			this.newsInfo();
		},
		methods: {
			newsInfo() {
				var id = this.$route.params.id;

				this.$http.post(this.path + 'index/getNewsInfo?id=' + id).then(function(response) {
					if(response.status === 200) {
						var data = response.body;
						this.newInfo = data.newsInfo;
						var time = this.newInfo.create_time;
						this.year = time.substring(0, 4);
						this.day = time.substring(5, 7) + "/" + time.substring(8, 10);
						this.dateTime = time.substring(11, 16);
					}
				})
			}
		}
	}
</script>

<style>
	@import "../assets/css/common.css";
	@import "../assets/css/news.css";
</style>


// WEBPACK FOOTER //
// src/components/NewsInfo.vue